/** Auto generated API client entry file for develop */
import { Configuration } from '@rbx/clients';
import unifiedLoggerClient from '@modules/eventStream/unifiedLoggerClient';
import {
  AssetsApi,
  GroupsApi,
  IconApi,
  PlacesApi,
  SearchApi,
  StatisticsApi,
  UserApi,
  UniversesApi,
  UniverseSettingsApi,
  SocialLinksApi,
  ThumbnailsApi,
  TeamCreateApi,
  RobloxWebWebAPIModelsApiArrayResponseRobloxApiDevelopModelsGroupModel,
  RobloxWebWebAPIModelsApiPageResponseRobloxApiDevelopModelsUniverseModel,
  RobloxApiDevelopModelsDevStatsCreatorDashboardMetadataResponse,
  RobloxApiDevelopModelsDeveloperProductAggregationResponse,
  RobloxApiDevelopModelsLiveStatsResponseModel,
  RobloxApiDevelopModelsPlaceCompatibilityModel,
  RobloxApiDevelopModelsResponsePlaceCompatibilitiesResponse,
  RobloxApiDevelopModelsResponseStatisticsAgeDataResponse,
  RobloxApiDevelopModelsResponseStatisticsRange,
  RobloxApiDevelopModelsStatisticsResponse,
  RobloxApiDevelopModelsUniverseModel,
  RobloxApiDevelopModelsUniverseSettingsResponse,
  RobloxApiDevelopModelsDeveloperProductRevenue,
  RobloxWebWebAPIModelsApiArrayResponseRobloxApiDevelopAssetModel,
  RobloxWebWebAPIModelsApiPageResponseRobloxApiDevelopModelsIPlaceModel,
  RobloxApiDevelopAssetModel,
  RobloxApiDevelopAssetCreator,
  V1AssetsGetRequest,
  V1GroupsGroupIdUniversesGetRequest,
  V1GroupsGroupIdUniversesGetSortOrderEnum,
  V1GroupsGroupIdUniversesGetLimitEnum,
  V1PlacesPlaceIdStatsTypeGetTypeEnum,
  V1PlacesPlaceIdStatsTypeGetGranularityEnum,
  V1PlacesPlaceIdStatsTypeGetDivisionTypeEnum,
  V1PlacesPlaceIdStatsDeveloperProductAggregationGetTimeFrameEnum,
  V1UniversesUniverseIdConfigurationPatchRequest,
  V1UniversesUniverseIdPlacesGetLimitEnum,
  V1UniversesUniverseIdThumbnailsAltTextPostRequest,
  V1UniversesUniverseIdPlacesGetSortOrderEnum,
  V1UserUniversesGetRequest,
  V1UserUniversesGetSortOrderEnum,
  V1UserUniversesGetLimitEnum,
  V1SearchUniversesGetSortOrderEnum,
  V1SearchUniversesGetLimitEnum,
  V1UniversesUniverseIdSocialLinksMetadataGetRequest,
  RobloxApiDevelopSocialLinksMetadataResponse,
  V1UniversesUniverseIdSocialLinksSocialLinkIdDeleteRequest,
  V1UniversesUniverseIdSocialLinksPostRequest,
  RobloxApiDevelopSocialLinkRequestTypeEnum,
  RobloxApiDevelopSocialLinkResponse,
  V1UniversesUniverseIdSocialLinksSocialLinkIdPatchRequest,
  V1AssetsAssetIdPatchRequest,
  V1UniversesUniverseIdThumbnailsAutoGeneratedPostRequest,
  V1UniversesUniverseIdThumbnailsVideoPostRequest,
  V1UniversesUniverseIdThumbnailsOrderPostRequest,
  V1UniversesUniverseIdThumbnailsThumbnailIdDeleteRequest,
  V1AssetsAssetIdPublishedVersionsGetSortOrderEnum,
  V1AssetsAssetIdPublishedVersionsGetLimitEnum,
  V1AssetsAssetIdSavedVersionsGetSortOrderEnum,
  RobloxDevelopApiUpdateAssetRequest,
  RobloxApiDevelopModelsIconRequestIconTypeEnum,
  RobloxWebWebAPIModelsApiArrayResponseSystemString,
  RobloxApiDevelopModelsPrivateServerDetailsResponse,
  RobloxWebWebAPIModelsApiArrayResponseRobloxApiDevelopModelsUniverseModel,
  V1PlacesPlaceIdMediaGetRequest,
  V1AssetsAssetIdSavedVersionsGetLimitEnum,
  RobloxWebWebAPIModelsApiArrayResponseRobloxApiDevelopModelsResponsePlaceMediaItemResponse,
  RobloxApiDevelopModelsUniversePermissionsModel,
  V1UniversesUniverseIdTeamcreatePatchRequest,
  RobloxApiDevelopModelsActivationEligibilityResponse,
  RobloxApiDevelopModelsUserPublicPublishEligibilityResponse,
} from '@rbx/clients/develop/v1';
import {
  RobloxApiDevelopModelsUniverseSettingsResponseV2,
  UniverseSettingsApi as UniverseSettingsApiV2,
  V2UniversesUniverseIdConfigurationPatchRequest,
  UniversesApi as UniversesApiV2,
  PlacesApi as PlacesApiV2,
  V2PlacesPlaceIdGetRequest,
  RobloxApiDevelopModelsPlaceModelV2,
  V2PlacesPlaceIdPatchRequest,
  RobloxApiDevelopModelsUniverseSettingsRequestV2PlayableDevicesEnum,
  RobloxApiDevelopAssetVersion,
  RobloxWebWebAPIModelsApiPageResponseRobloxApiDevelopAssetVersion,
  RobloxApiDevelopModelsUniverseSettingsRequestV2FiatProductChangeTypeEnum,
} from '@rbx/clients/develop/v2';
import UniverseCreator from './enums/UniverseCreator';
import UniverseSort from './enums/UniverseSort';
import ConfigureUniverseErrorCodes from './enums/ConfigureUniverseErrorCodes';
import ActivateExperienceErrorCodes from './enums/ActivateExperienceErrorCodes';
import ConfigureSocialLinkErrorCodes from './enums/ConfigureSocialLinkErrorCodes';
import GameUpdateNotificationsErrorCodes from './enums/GameUpdateNotificationsErrorCodes';
import {
  UploadAutoGeneratedThumbnailErrorCodes,
  UploadVideoThumbnailErrorCodes,
  UploadImageThumbnailErrorCodes,
  ReorderThumbnailErrorCodes,
  DeleteThumbnailErrorCodes,
  UpdateAltTextErrorCodes,
} from './enums/ConfigurePlaceThumbnailErrorCodes';
import SetAutoGeneratedPlaceIconErrorCodes from './enums/SetAutoGeneratedPlaceIconErrorCodes';
import { getBEDEV1ServiceBasePath } from '../utils';
import tryParseResponseError from '../utils/tryParseResponseError';
import GenericBEDEV1Error from '../errors/GenericBEDEV1Error';

export { RobloxApiDevelopSocialLinkRequestTypeEnum as SocialLinkTypesForRequest } from '@rbx/clients/develop';

export type GroupsResponse = RobloxWebWebAPIModelsApiArrayResponseRobloxApiDevelopModelsGroupModel;
export type UniverseResponse = RobloxApiDevelopModelsUniverseModel;
export type UniversesResponse =
  RobloxWebWebAPIModelsApiPageResponseRobloxApiDevelopModelsUniverseModel;
export type DeveloperProductsResponse = Required<RobloxApiDevelopModelsDeveloperProductRevenue>;
export type SearchUniversesResponse =
  RobloxWebWebAPIModelsApiPageResponseRobloxApiDevelopModelsUniverseModel;
export type StatMetadataResponse = RobloxApiDevelopModelsDevStatsCreatorDashboardMetadataResponse;
export type LiveStatsResponse = RobloxApiDevelopModelsLiveStatsResponseModel;
export type HistoricalDataResponse = RobloxApiDevelopModelsStatisticsResponse;
export type HistoricalDataResponseDataObject = RobloxApiDevelopModelsResponseStatisticsRange;
export type FilteredDeviceModel = RobloxApiDevelopModelsPlaceCompatibilityModel;
export type DeveloperProductRevenueModel = RobloxApiDevelopModelsDeveloperProductRevenue;
export type DeveloperProductAggregationResponse =
  RobloxApiDevelopModelsDeveloperProductAggregationResponse;
export type DeveloperProductAggregationGetTimeFrameType =
  keyof typeof V1PlacesPlaceIdStatsDeveloperProductAggregationGetTimeFrameEnum;
export type DevelopAssetDetailsResponse = RobloxApiDevelopAssetModel;
export type DevelopAssetCreator = RobloxApiDevelopAssetCreator;
export type SocialLinksMetadata = RobloxApiDevelopSocialLinksMetadataResponse;
export type SaveSocialLinkResponse = RobloxApiDevelopSocialLinkResponse;

export {
  V1PlacesPlaceIdStatsTypeGetTypeEnum as HistoricalDataTypeEnum,
  V1PlacesPlaceIdStatsTypeGetGranularityEnum as HistoricalDataGranularityEnum,
  V1PlacesPlaceIdStatsTypeGetDivisionTypeEnum as HistoricalDataDivisionEnum,
  V1PlacesPlaceIdStatsDeveloperProductAggregationGetTimeFrameEnum as DeveloperProductAggregationGetTimeFrameEnum,
  RobloxApiDevelopAssetModelGenresEnum as AssetGenresTypeEnum,
  RobloxApiDevelopModelsUniverseSettingsResponsePlayableDevicesEnum as DevicesType,
  RobloxApiDevelopModelsUniverseSettingsResponseFiatModerationStatusEnum as FiatProductModerationStatus,
  RobloxApiDevelopModelsIconRequestIconTypeEnum as PlaceIconType,
} from '@rbx/clients/develop';

export { RobloxApiDevelopModelsUniverseSettingsRequestV2FiatProductChangeTypeEnum as FiatProductChangeType } from '@rbx/clients/develop/v2';

export {
  UniverseSort,
  ConfigureUniverseErrorCodes,
  ActivateExperienceErrorCodes,
  ConfigureSocialLinkErrorCodes,
  GameUpdateNotificationsErrorCodes,
  UploadAutoGeneratedThumbnailErrorCodes,
  UploadVideoThumbnailErrorCodes,
  UploadImageThumbnailErrorCodes,
  SetAutoGeneratedPlaceIconErrorCodes,
  ReorderThumbnailErrorCodes,
  DeleteThumbnailErrorCodes,
  UpdateAltTextErrorCodes,
};

export class DevelopClient {
  private assetsApi: AssetsApi;

  private groupsApi: GroupsApi;

  private placesApi: PlacesApi;

  private searchApi: SearchApi;

  private statisticsApi: StatisticsApi;

  private universesApi: UniversesApi;

  private universesApiV2: UniversesApiV2;

  private universeSettingsApi: UniverseSettingsApi;

  private universeSettingsApiV2: UniverseSettingsApiV2;

  private userApi: UserApi;

  private socialLinksApi: SocialLinksApi;

  private placesApiV2: PlacesApiV2;

  private thumbnailsApi: ThumbnailsApi;

  private iconApi: IconApi;

  private teamCreateApi: TeamCreateApi;

  constructor(basePath: string = getBEDEV1ServiceBasePath('develop')) {
    const defaultConfiguration = new Configuration({
      robloxSiteDomain: process.env.robloxSiteDomain,
      basePath,
      credentials: 'include',
      unifiedLogger: unifiedLoggerClient,
    });

    this.assetsApi = new AssetsApi(defaultConfiguration);
    this.groupsApi = new GroupsApi(defaultConfiguration);
    this.placesApi = new PlacesApi(defaultConfiguration);
    this.searchApi = new SearchApi(defaultConfiguration);
    this.statisticsApi = new StatisticsApi(defaultConfiguration);
    this.universesApi = new UniversesApi(defaultConfiguration);
    this.universesApiV2 = new UniversesApiV2(defaultConfiguration);
    this.universeSettingsApi = new UniverseSettingsApi(defaultConfiguration);
    this.universeSettingsApiV2 = new UniverseSettingsApiV2(defaultConfiguration);
    this.userApi = new UserApi(defaultConfiguration);
    this.socialLinksApi = new SocialLinksApi(defaultConfiguration);
    this.placesApiV2 = new PlacesApiV2(defaultConfiguration);
    this.thumbnailsApi = new ThumbnailsApi(defaultConfiguration);
    this.iconApi = new IconApi(defaultConfiguration);
    this.teamCreateApi = new TeamCreateApi(defaultConfiguration);
  }

  async isUserEmailVerified(): Promise<boolean> {
    const response = await this.userApi.v1UserIsVerifiedCreatorGet();
    return !!response.isVerifiedCreator;
  }

  // Return groups having the manage games permission
  getGroups(): Promise<GroupsResponse> {
    return this.userApi.v1UserGroupsCanmanageGet();
  }

  // Return groups having the manage games or items permission
  getGroupsPlusManageItems(): Promise<GroupsResponse> {
    return this.userApi.v1UserGroupsCanmanagegamesoritemsGet();
  }

  getGroupUniverses(
    groupId: number,
    isArchived?: boolean,
    sortOrder?: keyof typeof V1GroupsGroupIdUniversesGetSortOrderEnum,
    limit?: V1GroupsGroupIdUniversesGetLimitEnum,
    cursor?: string,
  ): Promise<UniversesResponse> {
    const request: V1GroupsGroupIdUniversesGetRequest = {
      groupId,
      isArchived,
      sortOrder: sortOrder && V1GroupsGroupIdUniversesGetSortOrderEnum[sortOrder],
      limit,
      cursor,
    };
    return this.groupsApi.v1GroupsGroupIdUniversesGet(request);
  }

  getUserUniverses(
    isArchived?: boolean,
    sortOrder?: keyof typeof V1UserUniversesGetSortOrderEnum,
    limit?: V1UserUniversesGetLimitEnum,
    cursor?: string,
  ): Promise<UniversesResponse> {
    const request: V1UserUniversesGetRequest = {
      isArchived,
      sortOrder: sortOrder && V1UserUniversesGetSortOrderEnum[sortOrder],
      limit,
      cursor,
    };
    return this.userApi.v1UserUniversesGet(request);
  }

  getStatMetadata(): Promise<StatMetadataResponse> {
    return this.statisticsApi.v1StatsCreatorDashboardMetadataGet();
  }

  getUniverseDetails(universeId: number): Promise<RobloxApiDevelopModelsUniverseModel> {
    return this.universesApi.v1UniversesUniverseIdGet({ universeId });
  }

  async getUniversesDetails(
    universeIds: number[],
  ): Promise<RobloxWebWebAPIModelsApiArrayResponseRobloxApiDevelopModelsUniverseModel> {
    if (universeIds.length === 0) {
      return { data: [] };
    }
    const response = await this.universesApi.v1UniversesMultigetGet({ ids: universeIds });
    return {
      data: response.data || [],
    };
  }

  getUniversePermissions(
    universeId: number,
  ): Promise<RobloxApiDevelopModelsUniversePermissionsModel> {
    return this.universesApi.v1UniversesUniverseIdPermissionsGet({ universeId });
  }

  getPlaceMedia(
    placeId: number,
  ): Promise<RobloxWebWebAPIModelsApiArrayResponseRobloxApiDevelopModelsResponsePlaceMediaItemResponse> {
    const request: V1PlacesPlaceIdMediaGetRequest = {
      placeId,
    };
    return this.placesApi.v1PlacesPlaceIdMediaGet(request);
  }

  getPlacesOfUniverse(
    universeId: number,
    sortOrder: V1UniversesUniverseIdPlacesGetSortOrderEnum,
    limit: V1UniversesUniverseIdPlacesGetLimitEnum,
    cursor: string,
    isUniverseCreation = false,
  ): Promise<RobloxWebWebAPIModelsApiPageResponseRobloxApiDevelopModelsIPlaceModel> {
    return this.universesApi.v1UniversesUniverseIdPlacesGet({
      universeId,
      sortOrder,
      limit,
      cursor,
      isUniverseCreation,
    });
  }

  async getActivationEligibilityForUniverse(
    universeId: number,
  ): Promise<RobloxApiDevelopModelsActivationEligibilityResponse> {
    return this.universesApi.v1UniversesUniverseIdActivationEligibilityGet({ universeId });
  }

  async getActivationEligibilityForUser(): Promise<RobloxApiDevelopModelsUserPublicPublishEligibilityResponse> {
    return this.universesApi.v1UniversesUserPublicPublishEligibilityGet();
  }

  getFilteredDevices(
    placeId: number,
  ): Promise<RobloxApiDevelopModelsResponsePlaceCompatibilitiesResponse> {
    return this.placesApi.v1PlacesPlaceIdCompatibilitiesGet({ placeId });
  }

  getLiveStats(universeId: number): Promise<LiveStatsResponse> {
    return this.universesApi.v1UniversesUniverseIdLiveStatsGet({ universeId });
  }

  getHistoricalData(
    placeId: number,
    type: V1PlacesPlaceIdStatsTypeGetTypeEnum,
    granularity: V1PlacesPlaceIdStatsTypeGetGranularityEnum,
    divisionType: V1PlacesPlaceIdStatsTypeGetDivisionTypeEnum,
  ): Promise<HistoricalDataResponse> {
    return this.statisticsApi.v1PlacesPlaceIdStatsTypeGet({
      placeId,
      type,
      granularity,
      divisionType,
    });
  }

  getHistoricalDataAgeAvailable(
    placeId: number,
  ): Promise<RobloxApiDevelopModelsResponseStatisticsAgeDataResponse> {
    return this.statisticsApi.v1PlacesPlaceIdStatsIsAgeDataAvailableGet({ placeId });
  }

  getUniverseConfiguration(
    universeId: number,
  ): Promise<RobloxApiDevelopModelsUniverseSettingsResponse> {
    return this.universeSettingsApi.v1UniversesUniverseIdConfigurationGet({ universeId });
  }

  getUniverseConfigurationV2(
    universeId: number,
  ): Promise<RobloxApiDevelopModelsUniverseSettingsResponse> {
    return this.universeSettingsApi.v1UniversesUniverseIdConfigurationGet({ universeId });
  }

  setUniverseConfiguration(
    universeId: number,
    isArchived: boolean,
  ): Promise<RobloxApiDevelopModelsUniverseSettingsResponse> {
    const request: V1UniversesUniverseIdConfigurationPatchRequest = {
      universeId,
      model: { isArchived },
    };
    return this.universeSettingsApi.v1UniversesUniverseIdConfigurationPatch(request);
  }

  setUniverseConfigurationV2(
    universeId: number,
    name?: string,
    description?: string,
    isStudioAccessToApisAllowed?: boolean,
    MeshTextureApiAccessAllowed?: boolean,
    allowPrivateServers?: boolean,
    privateServerPrice?: number,
    isFriendsOnly?: boolean,
    playableDevices?: Array<RobloxApiDevelopModelsUniverseSettingsRequestV2PlayableDevicesEnum>,
    isForSale?: boolean,
    price?: number,
    fiatBasePriceId?: string,
    fiatProductChangeType?: RobloxApiDevelopModelsUniverseSettingsRequestV2FiatProductChangeTypeEnum,
  ): Promise<RobloxApiDevelopModelsUniverseSettingsResponseV2> {
    const request: V2UniversesUniverseIdConfigurationPatchRequest = {
      universeId,
      model: {
        name,
        description,
        studioAccessToApisAllowed: isStudioAccessToApisAllowed,
        isMeshTextureApiAccessAllowed: MeshTextureApiAccessAllowed,
        allowPrivateServers,
        privateServerPrice,
        isFriendsOnly,
        playableDevices,
        isForSale,
        price,
        fiatBasePriceId,
        fiatProductChangeType,
      },
    };
    return this.universeSettingsApiV2.v2UniversesUniverseIdConfigurationPatch(request);
  }

  async shutDownAllServers(universeId: number): Promise<void> {
    try {
      await this.universesApiV2.v2UniversesUniverseIdShutdownPost({ universeId });
    } catch (e) {
      const error = await tryParseResponseError(e);
      if (error) {
        throw new GenericBEDEV1Error(error.code, error.message);
      } else {
        throw e;
      }
    }
  }

  async archiveAsset(assetId: number): Promise<void> {
    await this.assetsApi.v1AssetsAssetIdArchivePost({ assetId });
  }

  async restoreAsset(assetId: number): Promise<void> {
    await this.assetsApi.v1AssetsAssetIdRestorePost({ assetId });
  }

  async activateGame(universeId: number): Promise<void> {
    await this.universesApi.v1UniversesUniverseIdActivatePost({ universeId });
  }

  async deactivateGame(universeId: number): Promise<void> {
    await this.universesApi.v1UniversesUniverseIdDeactivatePost({ universeId });
  }

  getDeveloperProductAggregationByTimeFrame(
    placeId: number,
    timeFrame: keyof typeof V1PlacesPlaceIdStatsDeveloperProductAggregationGetTimeFrameEnum,
  ): Promise<RobloxApiDevelopModelsDeveloperProductAggregationResponse> {
    return this.statisticsApi.v1PlacesPlaceIdStatsDeveloperProductAggregationGet({
      placeId,
      timeFrame: V1PlacesPlaceIdStatsDeveloperProductAggregationGetTimeFrameEnum[timeFrame],
    });
  }

  searchUniverses(
    creatorType: keyof typeof UniverseCreator,
    keyword?: string,
    creatorId?: number,
    archived?: boolean,
    active?: boolean,
    sortBy?: UniverseSort,
    sortOrder?: keyof typeof V1SearchUniversesGetSortOrderEnum,
    limit?: V1SearchUniversesGetLimitEnum,
    cursor?: string,
  ): Promise<SearchUniversesResponse> {
    let q = '';
    if (typeof keyword !== 'undefined') {
      q += keyword;
    }

    if (typeof archived !== 'undefined') {
      q += ` archived:${archived ? 'True' : 'False'}`;
    }

    if (typeof active !== 'undefined') {
      q += ` active:${active ? 'True' : 'False'}`;
    }

    q += ` creator:${creatorType}`;

    if (creatorType === UniverseCreator.Group && typeof creatorId !== 'undefined') {
      q += ` groups:${creatorId}`;
    }

    const sort: Array<string> = [];
    if (typeof sortBy !== 'undefined') {
      const sortOrderPrefix = sortOrder === V1SearchUniversesGetSortOrderEnum.Desc ? '-' : '+';
      sort.push(sortOrderPrefix + sortBy);
    }

    return this.searchApi.v1SearchUniversesGet({
      q,
      sort,
      sortOrder: sortOrder && V1SearchUniversesGetSortOrderEnum[sortOrder],
      limit,
      cursor,
    });
  }

  async getAssetDetails(
    assetIds: Array<number>,
  ): Promise<RobloxWebWebAPIModelsApiArrayResponseRobloxApiDevelopAssetModel> {
    if (assetIds.length === 0) {
      return {
        data: [],
      };
    }
    const request: V1AssetsGetRequest = {
      assetIds,
    };
    return this.assetsApi.v1AssetsGet(request);
  }

  async updateAsset(assetId: number, request: RobloxDevelopApiUpdateAssetRequest): Promise<void> {
    try {
      const requestParameters: V1AssetsAssetIdPatchRequest = {
        assetId,
        request,
      };
      await this.assetsApi.v1AssetsAssetIdPatch(requestParameters);
    } catch (e) {
      const productError = await tryParseResponseError(e);
      if (productError) {
        throw new GenericBEDEV1Error(productError.code, productError.message);
      } else {
        throw e;
      }
    }
  }

  getSocialLinkMetadata(universeId: number) {
    const request: V1UniversesUniverseIdSocialLinksMetadataGetRequest = { universeId };
    return this.socialLinksApi.v1UniversesUniverseIdSocialLinksMetadataGet(request);
  }

  deleteSocialLink(universeId: number, socialLinkId: number) {
    const request: V1UniversesUniverseIdSocialLinksSocialLinkIdDeleteRequest = {
      universeId,
      socialLinkId,
    };
    return this.socialLinksApi.v1UniversesUniverseIdSocialLinksSocialLinkIdDelete(request);
  }

  saveSocialLink(
    universeId: number,
    type: RobloxApiDevelopSocialLinkRequestTypeEnum,
    url: string,
    title: string,
  ) {
    const postRequest: V1UniversesUniverseIdSocialLinksPostRequest = {
      universeId,
      request: { type, url, title },
    };
    return this.socialLinksApi.v1UniversesUniverseIdSocialLinksPost(postRequest);
  }

  updateSocialLink(
    universeId: number,
    socialLinkId: number,
    type: RobloxApiDevelopSocialLinkRequestTypeEnum,
    url: string,
    title: string,
  ) {
    const patchSocialLinkRequest: V1UniversesUniverseIdSocialLinksSocialLinkIdPatchRequest = {
      universeId,
      socialLinkId,
      request: { type, url, title },
    };
    return this.socialLinksApi.v1UniversesUniverseIdSocialLinksSocialLinkIdPatch(
      patchSocialLinkRequest,
    );
  }

  async getPlaceDetailInfo(
    requestParameters: V2PlacesPlaceIdGetRequest,
    initOverrides?: RequestInit,
  ): Promise<RobloxApiDevelopModelsPlaceModelV2> {
    try {
      return await this.placesApiV2.v2PlacesPlaceIdGet(requestParameters, initOverrides);
    } catch (e) {
      const error = await tryParseResponseError(e);
      if (error) {
        throw new GenericBEDEV1Error(error.code, error.message);
      } else {
        throw e;
      }
    }
  }

  async patchPlaceConfigurationInfo(
    requestParameters: V2PlacesPlaceIdPatchRequest,
    initOverrides?: RequestInit,
  ): Promise<RobloxApiDevelopModelsPlaceModelV2> {
    try {
      return await this.placesApiV2.v2PlacesPlaceIdPatch(requestParameters, initOverrides);
    } catch (e) {
      const error = await tryParseResponseError(e);
      if (error) {
        throw new GenericBEDEV1Error(error.code, error.message);
      } else {
        throw e;
      }
    }
  }

  async uploadAutoGeneratedThumbnail(universeId: number) {
    const request: V1UniversesUniverseIdThumbnailsAutoGeneratedPostRequest = { universeId };
    return this.thumbnailsApi.v1UniversesUniverseIdThumbnailsAutoGeneratedPost(request);
  }

  async uploadVideoThumbnail(universeId: number, url: string) {
    const request: V1UniversesUniverseIdThumbnailsVideoPostRequest = {
      universeId,
      request: { url },
    };
    return this.thumbnailsApi.v1UniversesUniverseIdThumbnailsVideoPost(request);
  }

  async updateThumbnailAltText(
    universeId: number,
    mediaAssetId: number,
    mediaAssetAltText: string,
  ) {
    const request: V1UniversesUniverseIdThumbnailsAltTextPostRequest = {
      universeId,
      request: { mediaAssetId, mediaAssetAltText },
    };
    return this.thumbnailsApi.v1UniversesUniverseIdThumbnailsAltTextPost(request);
  }

  async getGenresList(
    initOverrides?: RequestInit,
  ): Promise<RobloxWebWebAPIModelsApiArrayResponseSystemString> {
    try {
      return await this.assetsApi.v1AssetsGenresGet(initOverrides);
    } catch (e) {
      const error = await tryParseResponseError(e);
      if (error) {
        throw new GenericBEDEV1Error(error.code, error.message);
      } else {
        throw e;
      }
    }
  }

  async setUniverseIcon(
    universeId: number,
    iconType: RobloxApiDevelopModelsIconRequestIconTypeEnum,
  ) {
    try {
      const request = {
        universeId,
        request: {
          iconType,
        },
      };
      await this.iconApi.v1UniversesUniverseIdIconPost(request);
    } catch (e) {
      const error = await tryParseResponseError(e);
      if (error) {
        throw new GenericBEDEV1Error(error.code, error.message);
      } else {
        throw e;
      }
    }
  }

  async reorderThumbnails(universeId: number, thumbnailIds: Array<number>) {
    const request: V1UniversesUniverseIdThumbnailsOrderPostRequest = {
      universeId,
      request: { thumbnailIds },
    };
    return this.thumbnailsApi.v1UniversesUniverseIdThumbnailsOrderPost(request);
  }

  async deleteThumbnail(universeId: number, thumbnailId: number) {
    const request: V1UniversesUniverseIdThumbnailsThumbnailIdDeleteRequest = {
      universeId,
      thumbnailId,
    };
    return this.thumbnailsApi.v1UniversesUniverseIdThumbnailsThumbnailIdDelete(request);
  }

  async getUniverseConfigurationVIPServer(
    universeId: number,
    initOverrides?: RequestInit,
  ): Promise<RobloxApiDevelopModelsPrivateServerDetailsResponse> {
    try {
      const request = {
        universeId,
      };
      return await this.universeSettingsApi.v1UniversesUniverseIdConfigurationVipServersGet(
        request,
        initOverrides,
      );
    } catch (e) {
      const error = await tryParseResponseError(e);
      if (error) {
        throw new GenericBEDEV1Error(error.code, error.message);
      } else {
        throw e;
      }
    }
  }

  async getAssetPublishedVersions(
    assetId: number,
    sortOrder?: V1AssetsAssetIdPublishedVersionsGetSortOrderEnum,
    limit?: V1AssetsAssetIdPublishedVersionsGetLimitEnum,
    cursor?: string,
  ): Promise<RobloxWebWebAPIModelsApiPageResponseRobloxApiDevelopAssetVersion> {
    try {
      const request = { assetId, sortOrder, limit, cursor };
      return await this.assetsApi.v1AssetsAssetIdPublishedVersionsGet(request);
    } catch (e) {
      const error = await tryParseResponseError(e);
      if (error) {
        throw new GenericBEDEV1Error(error.code, error.message);
      } else {
        throw e;
      }
    }
  }

  async postAssetPublishedVersions(
    assetId: number,
    assetVersionNumber: number,
  ): Promise<RobloxApiDevelopAssetVersion> {
    try {
      const request = { assetId, assetVersionNumber };
      return await this.assetsApi.v1AssetsAssetIdRevertVersionPost(request);
    } catch (e) {
      const error = await tryParseResponseError(e);
      if (error) {
        throw new GenericBEDEV1Error(error.code, error.message);
      } else {
        throw e;
      }
    }
  }

  async patchAssetConfiguration(assetId: number, request: RobloxDevelopApiUpdateAssetRequest) {
    try {
      return await this.assetsApi.v1AssetsAssetIdPatch({ assetId, request });
    } catch (e) {
      const error = await tryParseResponseError(e);
      if (error) {
        throw new GenericBEDEV1Error(error.code, error.message);
      } else {
        throw e;
      }
    }
  }

  async getAssetSavedVersions(
    assetId: number,
    sortOrder?: V1AssetsAssetIdSavedVersionsGetSortOrderEnum,
    limit?: V1AssetsAssetIdSavedVersionsGetLimitEnum,
    cursor?: string,
  ) {
    try {
      return await this.assetsApi.v1AssetsAssetIdSavedVersionsGet({
        assetId,
        sortOrder,
        limit,
        cursor,
      });
    } catch (e) {
      const error = await tryParseResponseError(e);
      if (error) {
        throw new GenericBEDEV1Error(error.code, error.message);
      } else {
        throw e;
      }
    }
  }

  async postAssetRevertVersion(assetId: number, assetVersionNumber: number) {
    try {
      return await this.assetsApi.v1AssetsAssetIdRevertVersionPost({ assetId, assetVersionNumber });
    } catch (e) {
      const error = await tryParseResponseError(e);
      if (error) {
        throw new GenericBEDEV1Error(error.code, error.message);
      } else {
        throw e;
      }
    }
  }

  async getUserUniversePermissions(universeIds: number[]) {
    return this.universesApi.v1UniversesMultigetPermissionsGet({
      ids: universeIds,
    });
  }

  /**
   * Toggle Team Create for a universe
   * @param universeId The ID of the universe to toggle Team Create for
   * @param enabled Whether to enable (true) or disable (false) Team Create
   */
  async toggleTeamCreate(universeId: number, enabled: boolean): Promise<void> {
    try {
      const request: V1UniversesUniverseIdTeamcreatePatchRequest = {
        universeId,
        request: {
          isEnabled: enabled,
        },
      };
      await this.teamCreateApi.v1UniversesUniverseIdTeamcreatePatch(request);
    } catch (e) {
      const error = await tryParseResponseError(e);
      if (error) {
        throw new GenericBEDEV1Error(error.code, error.message);
      } else {
        throw e;
      }
    }
  }
}

export default new DevelopClient();
